import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/payment/package/product/installments', config);
}

const get = async (id) => {
    return FinanceApi.get('/payment/package/product/installments/' + id);
}

const store = async (data) => {
    if (typeof data.id != 'undefined' && data.id>0) {
        return FinanceApi.put('/payment/package/product/installments/' + data.id, data);
    }
    return FinanceApi.post('/payment/package/product/installments', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/payment/package/product/installments/' + id, formData);
}

const del = async (id) => {
    return FinanceApi.delete('/payment/package/product/installments/' + id);
}

const importInstallments = async (data) => {
    return FinanceApi.post('/payment/package/product/installments/import', data);
}

export default {
    getAll,
    get,
    store,
    update,
    del,
    importInstallments
}
